<template>
    <div>
        <div class="bg-white px-3 py-1 mt-9">
            <div class="flex items-center justify-between" style="height: 40px">
                <div class="h-full flex items-center">
                    <div class="flex items-center mr-8">
                        <div class="table__search-input-wrapper">
                            <span class="pr-2">
                                <search-icon />
                            </span>

                            <input type="text" class="table__search-input" placeholder="Search..." v-model="query" />
                            <div @click="showFilterModal = true" class="cursor-pointer"><search-drop-down-icon /></div>

                        </div>
                    </div>
                </div>

                <primary-button buttonText="Create New Booking" :loading="false"
                    @click="$router.push({ name: 'NewConsolidation' })" />
            </div>

            <div class="py-5 bg-white w-100 flex items-center justify-center mt-5" style="height: 60vh"
                v-if="loadingConsolidations">
                <loader />
            </div>

            <div v-else-if="!(consolidations && consolidations.length)"
                class="bg-white w-100 flex justify-center flex-col items-center p-5 my-5">
                <empty-table-icon />
                <p class="font-semibold pt-3 pb-5">No Items found!</p>
            </div>

            <div v-else>
                <div class="table-wrapper" id="table-wrapper">
                    <table class="custom-table responsive-table">
                        <thead>
                            <tr>
                                <th class="width-xs">
                                    <input type="checkbox" class="checkbox" />
                                </th>
                                <th v-for="header in activeHeaders" :key="header">{{ header.name }}</th>

                                <th class="relative width-xs" tabindex="-1">
                                    <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.7">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                                                    fill="#383F51" />
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                                                    fill="#383F51" />
                                            </g>
                                        </svg></span>

                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(consolidation, index) in consolidations" :key="consolidation.id"
                                class="cursor-pointer">
                                <td>
                                    <input type="checkbox" />
                                    <label :for="`consolidation${index}`" class="check-label"></label>
                                </td>

                                <td v-for="header in activeHeaders" :key="header">
                                    <!-- <span v-if="header.name === 'ORIGIN'">
                                        {{ consolidation.originationTerminal ? consolidation.originationTerminal.name :
                                            "N/A" }},<br />
                                        {{ consolidation.originationTerminal ? consolidation.originationTerminal.state :
                                            "N/A" }}
                                    </span> -->

                                    <!-- <span v-else-if="header.name === 'DESTINATION'">
                                        {{ consolidation.destinationTerminal ? consolidation.destinationTerminal.name :
                                            "N/A" }},<br />
                                        {{ consolidation.destinationTerminal ? consolidation.destinationTerminal.state :
                                            "N/A" }}
                                    </span> -->

                                    <!-- Special case for Status -->
                                    <!-- <span v-else-if="header.name === 'Order Status'">
                                        <button :title="consolidation.status.replace(/_/g, ' ')"
                                            :class="['order_status']"
                                            :style="{ ...statusColors(consolidation.status) }">{{
                                                consolidation.status.replace(/_/g, ' ').toLowerCase() }}</button>
                                    </span> -->

                                    <!-- <span v-else-if="header.name === 'Shipment Count'">
                                        {{ consolidation?.shipments?.length ?? 0 }}
                                    </span> -->

                                    <!-- <span v-else-if="header.name === 'Fleet Capacity'">
                                        {{ consolidation.fleet ? consolidation.fleet.carriageCapacity : "N/A" }} to
                                        {{ consolidation.fleet ? consolidation.fleet.currentLoadCapacity : "N/A" }}
                                    </span> -->

                                    <!-- <span v-else-if="header.name === 'Fleet + Driver'">

                                        {{ consolidation?.fleet?.equipment ?? "N/A" }}

                                        <span>
                                            {{ consolidation &&
                                                consolidation.fleet &&
                                                consolidation.fleet.driver &&
                                                consolidation.fleet.driver.firstname
                                                ? consolidation.fleet.driver.firstname
                                                :
                                                "N/A" }}
                                            {{ consolidation &&
                                                consolidation.fleet &&
                                                consolidation.fleet.driver &&
                                                consolidation.fleet.driver.lastname
                                                ? consolidation.fleet.driver.lastname
                                                :
                                                "N/A" }}
                                        </span>
                                    </span> -->

                                    <!-- <span v-else-if="header.name === 'Consolidation ID # + Date'">
                                        {{ consolidation?.consolidationReference ?? "N/A" }}
                                        <span class="block w-full opacity-50">{{ consolidation.createdAt ?
                                            consolidation.createdAt.split("T")[0] : "N/A" }}</span>
                                    </span> -->

                                    <span>
                                        {{ getNestedValue(consolidation, headerMap[header.name]) }}
                                    </span>
                                </td>


                                <td>
                                    <el-dropdown v-if="currentTab == 'active'">
                                        <button @click="
                                            (selectedID = consolidation.id),
                                            (selectedConsolidation = consolidation)
                                            ">
                                            <vertical-ellipsis />
                                        </button>

                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-if="currentTab == 'active'">
                                                <button class="flex items-center" @click="
                                                    (showConfirmCancelModal = true),
                                                    (selectedID = consolidation.id)
                                                    ">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path
                                                            d="M8 15.9947C12.4183 15.9947 16 12.4154 16 8C16 3.58462 12.4183 0.00524902 8 0.00524902C3.58172 0.00524902 0 3.58462 0 8C0 12.4154 3.58172 15.9947 8 15.9947Z"
                                                            fill="#D72638" />
                                                        <path
                                                            d="M10.5381 11.7741L11.7754 10.5369L5.46295 4.2244L4.2257 5.46165L10.5381 11.7741Z"
                                                            fill="white" />
                                                        <path
                                                            d="M5.46295 11.7757L11.7754 5.46326L10.5381 4.22601L4.2257 10.5385L5.46295 11.7757Z"
                                                            fill="white" />
                                                    </svg>

                                                    <span class="ml-2">Cancel</span>
                                                </button>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <pagination-control @paginate-pagesize-changed="perPageSize" />
        </div>
    </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";

export default {
    components: {
        PaginationControl
    },
    data() {
        return {
            query: "",
            showFilterModal: false,
            startDate: "",
            endDate: "",
            activeHeaders: [
                { name: "Shipping ID # + DateShipping ID # + Date" },
                { name: "Shipping Service + Est. Delivery Date" },
                { name: "Gross Weight(Kg)" },
                { name: "Special Handling" },
                { name: "Ship from (Origin)" },
                { name: "Ship to (Destination)" },
                { name: "Load Status" },
            ],
            headerMap: {
                "Shipping ID # + Date": '',
                "Shipping Service + Est. Delivery Date": '',
                "Gross Weight(Kg)": '',
                "Special Handling": '',
                "Ship from (Origin)": '',
                "Ship to (Destination)": "",
                "Load Status": "",
            },
        }
    },
    methods: {
        perPageSize(pageSize) {
            this.pageSize = pageSize
        },
    },
}
</script>

<style lang="scss" scoped></style>